module.exports = __webpack_public_path__ + "static/media/error.24917c70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/views/images/error.svg
// module id = 566
// module chunks = 0